import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const mailTemplateEditRoute: RouteConfig = {
  path: ':mailTemplateId',
  name: 'mailTemplateEdit',
  component: () => import(/* webpackChunkName: "MailTemplateEdit" */ '@/views/mainRoute/mailTemplate/Edit.vue'),
  props: { edit: true },
  beforeEnter: (to, from, next) => {
    store.commit('mailTemplate/setId', tryParseInt(to.params.mailTemplateId));
    Promise.all([store.dispatch('mailTemplate/list', { count: -1 }), store.dispatch('mailTemplate/get')]).then(() =>
      next()
    );
  }
};
